import dayjs from 'dayjs';

export const getWeekDay = (day: string) => (dayjs(day).day() + 6) % 7;
